// extracted by mini-css-extract-plugin
export default {"wcpaPage":"WcpaAudit_wcpaPage__ZJAtY","footer":"WcpaAudit_footer__Zov+o"};